import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import {filterBasicTypes} from '@adv-mt/mt-filter-basic'
import {filterWrapperBasicTypes} from '@adv-mt/mt-filter-wrapper-basic'
import {FormProvince} from '@adv-mt/mt-form-province'

import {BASE_CLASS} from '../../config.js'
import {WRAPPERS_BY_DESIGN} from './config.js'

const FormLocationProvince = ({aggregations, design, onChange, search}) => {
  const {domain} = useSuiContext()

  const config = domain.get('config')

  const {FILTER_NAMES} = config.get('searchFilters')

  const wrapper = WRAPPERS_BY_DESIGN[design] || filterWrapperBasicTypes.EMBEDDED_WITH_SEARCH_BAR

  return (
    <div className={`${BASE_CLASS}-province`}>
      <FormProvince
        aggregations={aggregations}
        initialSearch={search}
        onChange={onChange}
        type={filterBasicTypes.MULTI_SELECTION_NESTED}
        value={search[FILTER_NAMES.PROVINCE]}
        withLabel={false}
        wrapper={wrapper}
      />
    </div>
  )
}

FormLocationProvince.displayName = 'FormLocationProvince'
FormLocationProvince.propTypes = {
  aggregations: PropTypes.array,
  design: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  search: PropTypes.object
}

export default FormLocationProvince
